import React, { useState, useEffect, useRef } from "react";
import "./tutorOrderFormStyle.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faUser,
  faCalendarAlt,
  faBook,
  faChalkboardTeacher,
  faCommentAlt,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { URL } from "../../../config";
// const API_BASE = "http://localhost:4001";


const TutorserviceOrderForm = ({ user, formData, onClose, onSubmit, previousTutorName }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [orderData, setOrderData] = useState({
    // city: user?.city || "",
    address: user?.Address || "",
    mobile: user?.mobile || "",
  });

  const [divisions, setDivisions] = useState([]);  // [{Id,name,code}]
  const [areas, setAreas] = useState([]);          // [{Id,name}]
  const [selectedDivisionId, setSelectedDivisionId] = useState(null);
  const [selectedAreaId, setSelectedAreaId] = useState(null);
  const [errors, setErrors] = useState({ city: "", area: "", address: "" });
  const divisionRef = useRef(null);
  const areaRef = useRef(null);
  const addressRef = useRef(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [showBlockedPopup, setShowBlockedPopup] = useState(false);

  const penalty = user && user.penalty ? Number(user.penalty) : 0;
  const basePrice = Number(formData.salaryPerMonth) || 0;
  const finalPrice = user?.penaltyReserved ? basePrice : basePrice + (penalty || 0);

  useEffect(() => {
    if (user) {
      if (user.status === "Blocked") {
        setShowBlockedPopup(true);
        setShowForm(false);
      } else {
        setOrderData({
          city: user.city || "",
          address: user.Address || "",
          mobile: user.mobile || "",
        });
      }
    }
  }, [user]);

  // lock background scroll while modal open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = "auto"; };
  }, []);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setOrderData((prev) => ({ ...prev, [name]: value }));
  // };

  useEffect(() => {
  (async () => {
    try {
      const { data } = await axios.get(`${URL}/locations/divisions`, { params: { countryCode: "BD" } });
      setDivisions(data || []);
      if (user?.city) {
        const match = (data || []).find(d => d.name.toLowerCase() === String(user.city).toLowerCase());
        if (match) setSelectedDivisionId(match.Id);
      }
    } catch (e) {
      console.error("Failed to load divisions:", e);
      setDivisions([]);
    }
  })();
}, [user?.city]);

useEffect(() => {
  (async () => {
    if (!selectedDivisionId) {
      setAreas([]);
      setSelectedAreaId(null);
      return;
    }
    try {
      const { data } = await axios.get(`${URL}/locations/areas`, { params: { divisionId: selectedDivisionId } });
      setAreas(data || []);
      if (user?.area) {
        const match = (data || []).find(a => a.name.toLowerCase() === String(user.area).toLowerCase());
        setSelectedAreaId(match ? match.Id : null);
      } else {
        setSelectedAreaId(null);
      }
    } catch (e) {
      console.error("Failed to load areas:", e);
      setAreas([]);
      setSelectedAreaId(null);
    }
  })();
}, [selectedDivisionId, user?.area]);


const clearErr = (k) => setErrors(prev => ({ ...prev, [k]: "" }));

const handleDivisionChange = (e) => {
  const id = e.target.value ? Number(e.target.value) : null;
  setSelectedDivisionId(id);
  clearErr("city");
};

const handleAreaChange = (e) => {
  const id = e.target.value ? Number(e.target.value) : null;
  setSelectedAreaId(id);
  clearErr("area");
};

const handleAddressChange = (e) => {
  setOrderData(prev => ({ ...prev, address: e.target.value }));
  if (e.target.value?.trim()) clearErr("address");
};

const validate = () => {
  const next = {};
  if (!selectedDivisionId) next.city = "Please select your city";
  if (!selectedAreaId)     next.area = "Please select your area";
  if (!orderData.address?.trim()) next.address = "Please provide your address";
  setErrors(next);
  return Object.keys(next).length === 0;
};




  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const dateObj = new Date(dateStr);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("default", { month: "short" });
    const year = dateObj.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    if (!validate()) {
      if (!selectedDivisionId && divisionRef.current) {
        divisionRef.current.focus();
        divisionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      } else if (!selectedAreaId && areaRef.current) {
        areaRef.current.focus();
        areaRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      } else if (!orderData.address?.trim() && addressRef.current) {
        addressRef.current.focus();
        addressRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }

    const selectedDivision = divisions.find(d => d.Id === selectedDivisionId);
    const selectedArea = areas.find(a => a.Id === selectedAreaId);
    

    // Build payload using your server’s expected field names
    const finalOrderData = {
      userId: user.Id,
      usercity: selectedDivision?.name || "",
      userarea: selectedArea?.name || "",
      useraddress: orderData.address, 

      medium: formData.medium,
      classLevel: formData.classLevel,

      subject: Array.isArray(formData.subjects)
      ? formData.subjects.join(", ")
      : String(formData.subjects || ""),

      preferredTutorGender: (formData.tutorRequirements && formData.tutorRequirements.gender) || "Any",
      priorityInstitution: (formData.tutorRequirements && formData.tutorRequirements.university) || "Any",

      daysPerWeek: formData.daysPerWeek,
      hoursPerDay: formData.hoursPerDay,
      salary: formData.salaryPerMonth,
      tutorRequirements: formData.tutorRequirements,
      remarks: formData.notes,

      price: finalPrice, 
      date: formData.date,
      time: formData.time,
      status: "pending",

      useSameTutor: formData.useSameTutor,
      servitor_id: formData.useSameTutor ? formData.servitor_id : 0,

      serviceId: 7, // consider centralizing as a constant
    };

    try {
      setIsSubmitting(true);

      const token = localStorage.getItem("token");
      const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

      const response = await axios.post(`${URL}/tutor`, finalOrderData, { headers });
      console.log("Order placed successfully:", response.data);

      setShowForm(false);
      setShowSuccessPopup(true);
    } catch (error) {
      console.error("Error placing order:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const closePopup = () => {
    setShowSuccessPopup(false);
    onClose();
    onSubmit(); // tell parent to reset its state
    navigate("/profile/orderhistory");
  };

  const closeBlockedPopup = () => {
    setShowBlockedPopup(false);
    onClose();
  };


    // Normalize subjects so it works for: "All", array, or comma-separated string
  const normalizedSubjects = React.useMemo(() => {
    const s = formData.subjects;

    // Case 1: "All" (our special meaning: all subjects for this class)
    if (s === "All") {
      return ["All"];
    }

    // Case 2: already an array
    if (Array.isArray(s)) {
      return s;
    }

    // Case 3: backend / previous data like "Bangla, English"
    if (typeof s === "string" && s.trim()) {
      return s
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean);
    }

    // Fallback: nothing
    return [];
  }, [formData.subjects]);


  return (
    <>
      {showForm && (
        <div className="tutororder-modal-backdrop">
          <div className="tutororder-modal-content">
            <div className="tutororder-modal-header">
              <h2 className="tutororder-modal-title">
                {t("tutororderform.order_form.modal.title")}
              </h2>
              <button className="tutororder-modal-close" onClick={onClose}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            <div className="tutororder-modal-body">
              <div className="tutororder-two-column-grid">
                {/* Customer Info */}
                <div className="tutororder-modal-card">
                  <div className="tutororder-card-body">
                    <h3 className="tutororder-card-title">
                      <FontAwesomeIcon icon={faUser} />
                      {t(
                        "tutororderform.order_form.customer_information.title"
                      )}
                    </h3>
                    <div className="tutororder-form-grid">
                      <div className="tutororder-form-group">
                        <label className="tutororder-form-label">
                          {t(
                            "tutororderform.order_form.customer_information.labels.name"
                          )}
                        </label>
                        <input
                          type="text"
                          className="tutororder-form-control"
                          value={`${user.FirstName} ${user.LastName}`}
                          readOnly
                        />
                      </div>

                      <div className="tutororder-form-group">
                        <label className="tutororder-form-label">
                          {t(
                            "tutororderform.order_form.customer_information.labels.mobile"
                          )}
                        </label>
                        <input
                          type="text"
                          className="tutororder-form-control"
                          value={`${orderData.mobile}`}
                          readOnly
                        />
                      </div>

                      <div className="tutororder-form-group">
                        <label className="tutororder-form-label">
                          {t(
                            "tutororderform.order_form.customer_information.labels.city"
                          )}
                        </label>
                        <select
                          className="tutororder-form-control"
                          value={selectedDivisionId || ""}
                          onChange={handleDivisionChange}
                          onBlur={validate}
                          aria-invalid={Boolean(errors.city)}
                          aria-describedby={
                            errors.city ? "city-error" : undefined
                          }
                          ref={divisionRef}
                        >
                          <option value="">
                            {t(
                              "plumberorderform.order_form.customer_information.labels.city_placeholder"
                            )}
                          </option>
                          {divisions.map((d) => (
                            <option key={d.Id} value={d.Id}>
                              {d.name}
                            </option>
                          ))}
                        </select>
                        {errors.city && (
                          <div id="city-error" className="field-error">
                            {errors.city}
                          </div>
                        )}
                      </div>

                      {/* Area */}
                      <div className="tutororder-form-group">
                        <label className="tutororder-form-label">
                          {t(
                            "electricianorderform.order_form.customer_information.labels.area",
                            "Area"
                          )}
                        </label>
                        <select
                          className="tutororder-form-control"
                          value={selectedAreaId || ""}
                          onChange={handleAreaChange}
                          onBlur={validate}
                          disabled={!selectedDivisionId}
                          aria-invalid={Boolean(errors.area)}
                          aria-describedby={
                            errors.area ? "area-error" : undefined
                          }
                          ref={areaRef}
                        >
                          <option value="">
                            {!selectedDivisionId
                              ? t("Select City first")
                              : t("Select Area")}
                          </option>
                          {areas.map((a) => (
                            <option key={a.Id} value={a.Id}>
                              {a.name}
                            </option>
                          ))}
                        </select>
                        {errors.area && (
                          <div id="area-error" className="field-error">
                            {errors.area}
                          </div>
                        )}
                      </div>

                      <div className="tutororder-form-group">
                        <label className="tutororder-form-label">
                          {t(
                            "tutororderform.order_form.customer_information.labels.address"
                          )}
                        </label>
                        <textarea
                          name="address"
                          className="tutororder-form-control"
                          rows="3"
                          value={orderData.address}
                          onChange={handleAddressChange}
                          onBlur={validate}
                          aria-invalid={Boolean(errors.address)}
                          aria-describedby={
                            errors.address ? "address-error" : undefined
                          }
                          ref={addressRef}
                        />
                        {errors.address && (
                          <div id="address-error" className="field-error">
                            {errors.address}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Booking Details */}
                <div className="tutororder-modal-card">
                  <div className="tutororder-card-body">
                    <h3 className="tutororder-card-title">
                      <FontAwesomeIcon icon={faCalendarAlt} />
                      {t("tutororderform.order_form.booking_details.title")}
                    </h3>
                    <div className="tutororder-form-grid">
                      <div className="tutororder-form-group">
                        <label className="tutororder-form-label">
                          {t(
                            "tutororderform.order_form.booking_details.labels.date"
                          )}
                        </label>
                        <input
                          type="text"
                          className="tutororder-form-control"
                          value={formatDate(formData.date)}
                          readOnly
                        />
                      </div>

                      <div className="tutororder-form-group">
                        <label className="tutororder-form-label">
                          {t(
                            "tutororderform.order_form.booking_details.labels.time"
                          )}
                        </label>
                        <input
                          type="text"
                          className="tutororder-form-control"
                          value={formData.time}
                          readOnly
                        />
                      </div>

                      {/* Price summary (with penalty UI) */}
                      {!user.penaltyReserved && penalty > 0 ? (
                        <>
                          <div className="tutororder-form-group">
                            <label className="tutororder-form-label">
                              {t(
                                "tutororderform.order_form.booking_details.labels.base_price"
                              )}
                            </label>
                            <input
                              type="text"
                              className="tutororder-form-control"
                              value={`${basePrice} tk`}
                              readOnly
                            />
                          </div>
                          <div className="tutororder-form-group">
                            <label className="tutororder-form-label">
                              {t(
                                "tutororderform.order_form.booking_details.labels.penalty"
                              )}
                            </label>
                            <input
                              type="text"
                              className="tutororder-form-control tutororder-penalty-field"
                              value={`${penalty} tk`}
                              readOnly
                            />
                          </div>
                          <div className="tutororder-form-group">
                            <label className="tutororder-form-label">
                              {t(
                                "tutororderform.order_form.booking_details.labels.total_price"
                              )}
                            </label>
                            <input
                              type="text"
                              className="tutororder-form-control tutororder-total-price"
                              value={`${finalPrice} tk`}
                              readOnly
                            />
                          </div>
                        </>
                      ) : (
                        <div className="tutororder-form-group">
                          <label className="tutororder-form-label">
                            {t(
                              "tutororderform.order_form.booking_details.labels.total_price"
                            )}
                          </label>
                          <input
                            type="text"
                            className="tutororder-form-control tutororder-total-price"
                            value={`${finalPrice} tk`}
                            readOnly
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Service Details */}
              <div className="tutororder-modal-card">
                <div className="tutororder-card-body">
                  <h3 className="tutororder-card-title">
                    {t("tutororderform.order_form.service_details.title")}
                  </h3>

                  <div className="tutororder-services-section">
                    <div className="tutororder-service-category">
                      <h4 className="tutororder-category-header">
                        <FontAwesomeIcon icon={faBook} />
                        {t(
                          "tutororderform.order_form.service_details.categories.academic_details.title"
                        )}
                      </h4>
                      <div className="tutororder-services-grid">
                        <div className="tutororder-service-item">
                          <label className="tutororder-form-label">
                            {t(
                              "tutororderform.order_form.service_details.categories.academic_details.labels.medium"
                            )}
                          </label>
                          <div className="tutororder-service-value has-value">
                            {formData.medium}
                          </div>
                        </div>

                        <div className="tutororder-service-item">
                          <label className="tutororder-form-label">
                            {t(
                              "tutororderform.order_form.service_details.categories.academic_details.labels.classLevel"
                            )}
                          </label>
                          <div className="tutororder-service-value has-value">
                            {formData.classLevel}
                          </div>
                        </div>

                        <div className="tutororder-service-item tutororder-subjects-item">
                          <label className="tutororder-form-label">
                            {t(
                              "tutororderform.order_form.service_details.categories.academic_details.labels.subjects"
                            )}
                          </label>
                          {/* <div className="tutororder-subjects-list">
                            {formData.subjects.map((subject, index) => (
                              <span
                                key={index}
                                className="tutororder-subject-tag"
                              >
                                {subject}
                              </span>
                            ))}
                          </div> */}

                          <div className="tutororder-subjects-list">
                            {normalizedSubjects.length > 0 ? (
                              normalizedSubjects.map((subject, index) => (
                                <span
                                  key={index}
                                  className="tutororder-subject-tag"
                                >
                                  {subject === "All"
                                    ? t(
                                        "tutororderform.order_form.service_details.categories.academic_details.labels.all_subjects",
                                        "All Subjects"
                                      )
                                    : subject}
                                </span>
                              ))
                            ) : (
                              <span className="tutororder-subject-tag tutororder-subject-tag-empty">
                                {t(
                                  "tutororderform.order_form.service_details.categories.academic_details.labels.no_subjects_selected",
                                  "Not specified"
                                )}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="tutororder-service-category">
                      <h4 className="tutororder-category-header">
                        <FontAwesomeIcon icon={faCalendarAlt} />
                        {t(
                          "tutororderform.order_form.service_details.categories.schedule.title"
                        )}
                      </h4>
                      <div className="tutororder-services-grid">
                        <div className="tutororder-service-item">
                          <label className="tutororder-form-label">
                            {t(
                              "tutororderform.order_form.service_details.categories.schedule.labels.daysPerWeek"
                            )}
                          </label>
                          <div className="tutororder-service-value has-value">
                            {formData.daysPerWeek}{" "}
                            {t(
                              formData.daysPerWeek === 1
                                ? "tutororderform.order_form.service_details.unit"
                                : "tutororderform.order_form.service_details.units"
                            )}
                          </div>
                        </div>

                        <div className="tutororder-service-item">
                          <label className="tutororder-form-label">
                            {t(
                              "tutororderform.order_form.service_details.categories.schedule.labels.hoursPerDay"
                            )}
                          </label>
                          <div className="tutororder-service-value has-value">
                            {formData.hoursPerDay}{" "}
                            {t(
                              "tutororderform.order_form.service_details.hours"
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="tutororder-service-category">
                      <h4 className="tutororder-category-header">
                        <FontAwesomeIcon icon={faChalkboardTeacher} />
                        {t(
                          "tutororderform.order_form.service_details.categories.requirements.title"
                        )}
                      </h4>
                      <div className="tutororder-services-grid">
                        <div className="tutororder-service-item">
                          <label className="tutororder-form-label">
                            {t(
                              "tutororderform.order_form.service_details.categories.requirements.labels.university"
                            )}
                          </label>
                          <div className="tutororder-service-value has-value">
                            {formData.tutorRequirements.university ||
                              t(
                                "tutororderform.order_form.service_details.categories.requirements.any"
                              )}
                          </div>
                        </div>
                        <div className="tutororder-service-item">
                          <label className="tutororder-form-label">
                            {t(
                              "tutororderform.order_form.service_details.categories.requirements.labels.gender"
                            )}
                          </label>
                          <div className="tutororder-service-value has-value">
                            {formData.tutorRequirements.gender ||
                              t(
                                "tutororderform.order_form.service_details.categories.requirements.any"
                              )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {formData.useSameTutor && previousTutorName && (
                      <div className="tutororder-service-item tutororder-rebook-item">
                        <label className="tutororder-form-label tutororder-label-content">
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            className="tutororder-rebook-icon"
                          />
                          {t("tutororderform.order_form.rebook.label")}
                        </label>
                        <div className="tutororder-service-value tutororder-rebook-value">
                          <strong>{previousTutorName}</strong>
                        </div>
                      </div>
                    )}

                    {formData.notes && (
                      <div className="tutororder-service-item tutororder-remarks-item">
                        <label className="tutororder-form-label">
                          <FontAwesomeIcon
                            icon={faCommentAlt}
                            className="tutororder-remarks-icon"
                          />
                          {t(
                            "tutororderform.order_form.service_details.categories.requirements.labels.notes"
                          )}
                        </label>
                        <div className="tutororder-service-value has-value tutororder-remarks-value">
                          {formData.notes}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="tutororder-order-actions">
              <button
                className="tutororder-btn tutororder-btn-outline"
                onClick={onClose}
              >
                {t("tutororderform.order_form.actions.cancel")}
              </button>
              <button
                className="tutororder-btn tutororder-btn-primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                <FontAwesomeIcon icon={faBook} />
                {/* {t("tutororderform.order_form.actions.place_order")} */}
                {isSubmitting
                  ? t("tutororderform.order_form.actions.placing", "Placing...")
                  : t("tutororderform.order_form.actions.place_order")}
              </button>
            </div>
          </div>
        </div>
      )}

      {showSuccessPopup && (
        <div className="tutororder-success-popup">
          <div className="tutororder-success-popup-content">
            <h2>{t("tutororderform.order_form.success_popup.title")}</h2>
            <p>{t("tutororderform.order_form.success_popup.message1")}</p>
            <p>{t("tutororderform.order_form.success_popup.message2")}</p>
            <button
              className="tutororder-btn tutororder-btn-primary"
              onClick={closePopup}
            >
              {t("tutororderform.order_form.success_popup.button")}
            </button>
          </div>
        </div>
      )}

      {showBlockedPopup && (
        <div className="tutororder-success-popup">
          <div className="tutororder-success-popup-content">
            <h2>{t("tutororderform.order_form.blocked_popup.title")}</h2>
            <p>{t("tutororderform.order_form.blocked_popup.message1")}</p>
            <p>{t("tutororderform.order_form.blocked_popup.message2")}</p>
            <button
              className="tutororder-btn tutororder-btn-primary"
              onClick={closeBlockedPopup}
            >
              {t("tutororderform.order_form.blocked_popup.button")}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default TutorserviceOrderForm;
